import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = exact({
  text: PropTypes.string.isRequired,
});

function ErrorMessage(props) {
  return (
    <div className="ErrorMessage">
      <div
        className="ErrorMessage_content"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: props.text.replace(/\n/g, '<br/>'),
        }}
      />
    </div>
  );
}

ErrorMessage.propTypes = propTypes;

export default ErrorMessage;
